module.exports = __webpack_public_path__ + "img/Circles-menu-3.dafa4436.gif";